module.exports = __webpack_public_path__ + "static/media/tooth.f9bb4d14.svg";